export default () => ({
  commands: {
    addColor: (editor, { color }) => {
      editor.removeColor()
      editor.addMark({ type: "color", data: { color } })
    },
    removeColor: editor => {
      editor.value.marks
        .filter(mark => mark.type == "color")
        .map(mark => editor.removeMark(mark))
    }
  },
  queries: {
    getColor(editor) {
      const color = editor.value.marks.find(mark => mark.type === "color")
      return (color && color.data.get("color")) || ""
    }
  },
  renderMark(props, editor, next) {
    const { attributes, children, mark } = props

    switch (mark.type) {
      case "color":
        return (
          <span {...attributes} style={{ color: mark.data.get("color") }}>
            {children}
          </span>
        )
      default:
        return next()
    }
  }
})
